import { useNavigate as useNavigateBase } from 'react-router-dom';

export const useNavigate = () => {
    const navigateFunc = useNavigateBase();
    
    return (to, options = {}) => {
        navigateFunc(to, options);
    };
}